import { Routes, Route, Navigate, BrowserRouter } from 'react-router-dom';
import { FC } from 'react';

import publicRoutes from './routes/public.routes';
import privateRoutes from './routes/private.routes';
import { useAuth } from '@/features/Auth/lib/useAuth';

const AppRoutes: FC = () => {
  const { isAuth } = useAuth();

  return (
    <BrowserRouter>
      <Routes>
        {!isAuth && publicRoutes.map(({ path, element }) => (
          <Route key={path} path={path} element={element} />
        ))}

        {isAuth && privateRoutes.map(({ path, element }) => (
          <Route key={path} path={path} element={element} />
        ))}

        {isAuth && (
          <Route path="/" element={<Navigate to="/SalePlan" replace />} />
        )}
        {isAuth && (
          <Route path="*" element={<Navigate to="/SalePlan" replace />} />
        )}

        {!isAuth && (
          <Route path="*" element={<Navigate to="/" replace />} />
        )}
      </Routes>
    </BrowserRouter>
  );
};

export default AppRoutes; 